import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../_shared/base.service';
import { Observable } from 'rxjs';
import { Coupon } from '../_models/Coupon';
import { getUrl } from '../_shared/utils';
import { JWTTokenService } from './jwtToken.service';
import { map } from 'rxjs/operators';

@Injectable()
export class CouponService extends BaseService {

    constructor(private http: HttpClient, jwtTokenService: JWTTokenService) {
        super(http, jwtTokenService);
    }

    createCoupon(model: Coupon): Observable<any> {
        this.RemoveFromCache('couponList');
        const endpoint = getUrl('coupon');

        if (model.id) {
            return this.http.put(endpoint, model, this.buildOptions());
        } else {
            return this.http.post(endpoint, model, this.buildOptions());
        }
    }

    listCoupons(): Observable<Coupon[]> {
        return this.CachedCall('couponList',
            this.http.get<any[]>(getUrl('coupon'), this.buildOptions())
                .pipe(map(c => {
                    return c.map<Coupon>(cp => this.map(cp));
                })));
    }

    deleteCoupon(id: number): Observable<any> {
        this.RemoveFromCache('couponList');
        return this.http.delete(getUrl('coupon/' + id), this.buildOptions());
    }

    checkCoupon(id: number): Observable<any> {
        this.RemoveFromCache('couponList');
        return this.http.get(getUrl('coupon/check/' + id), this.buildOptions());
    }

    getCoupon(id: number): Observable<Coupon> {
        return this.http.get<Coupon>(getUrl('coupon/' + id), this.buildOptions()).pipe(map(c => this.map(c)));
    }

    private map(c: any): Coupon {
        const couponObj = JSON.parse(c.couponJson);

        return <Coupon>{
            id: c.couponId,
            foregroundColor: couponObj.foregroundColor,
            backgroundColor: couponObj.backGroundColor || couponObj.backgroundColor,
            description: couponObj.description,
            labelColor: couponObj.labelColor,
            barcodeMessage: couponObj.barcodeMessage,
            logoSmall: couponObj.logoSmall,
            iconSmall: couponObj.iconSmall,
            stripSmall: couponObj.stripSmall,
            logoLarge: couponObj.logoLarge,
            iconLarge: couponObj.iconLarge,
            stripLarge: couponObj.stripLarge,
            expirationInterval: {
                endDate: new Date(couponObj.expire?.endDate || couponObj.expire?.EndDate),
                startDate: new Date(couponObj.expire?.startDate || couponObj.expire?.StartDate)
            },
            barcodeType: couponObj.barcodeType,
            primaryField: couponObj.primaryField,
            primaryFieldBody: couponObj.primaryFieldBody,
            offer: couponObj.offer,
            provider: couponObj.provider,
            couponWalletId: couponObj.couponWalletId,
            couponTitle: couponObj.couponTitle,
            couponDisclaimer: couponObj.couponDisclaimer,
            couponNearbyStoresUrl: couponObj.couponNearbyStoresUrl,
            couponCustomerService: couponObj.couponCustomerService,
            pkPassUrl: c.pkPassUrl,
            googlePayUrl: c.googlePayUrl,
            timeZone: couponObj.timeZone,
        };
    }
}
